"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showCallerPermissionStub = exports.permissionStub = exports.filterByRole = exports.createViewPermissions = exports.createUser = exports.createSCViewPermissions = exports.createPermissions = exports.createEvent = exports.bootstrapShowCallerPermissions = void 0;
var _ = require("../..");
var EVENT_ID = 'someEventId';
var createEvent = exports.createEvent = function createEvent(role) {
  return {
    role: role
  };
};
var createUser = exports.createUser = function createUser(role) {
  return {
    _id: 123,
    teams: [],
    lastName: 'Drummond',
    firstName: 'Mandarin',
    testEventId: EVENT_ID,
    events: [{
      role: role,
      event: EVENT_ID
    }]
  };
};
var permissionStub = exports.permissionStub = function permissionStub() {
  return {
    RolePermissions: {
      foo: {
        permissions: []
      }
    }
  };
};
var showCallerPermissionStub = exports.showCallerPermissionStub = function showCallerPermissionStub() {
  return {
    RolePermissions: {
      ShowCaller: {
        permissions: []
      }
    }
  };
};
var filterByRole = exports.filterByRole = function filterByRole(permissions, role) {
  var adminRestrictedPermissions = [_.TAKE_SOURCE_LIVE, _.SOLO_SOURCE_LIVE, _.REMOVE_SOURCE_LIVE, _.CHANGE_LAYOUTS, _.MULTI_SELECT];
  if (role === 'ShowCaller') return permissions;else if (role === 'Contributor') {
    adminRestrictedPermissions.concat([_.EDIT_SETTINGS_TOGGLES, _.CREATE_DELETE_ENDPOINTS, _.START_STOP_ENDPOINT_STREAM]);
  }
  return permissions.filter(function (perm) {
    return !adminRestrictedPermissions.includes(perm.key);
  });
};
var createPermissions = exports.createPermissions = function createPermissions(permissionConstants, role) {
  var permissions = [];
  permissionConstants.map(function (pConst) {
    var permission = Object.create(null);
    permission.key = pConst;
    permissions.push(permission);
  });
  return filterByRole(permissions, role);
};
var bootstrapShowCallerPermissions = exports.bootstrapShowCallerPermissions = function bootstrapShowCallerPermissions(perms) {
  perms.RolePermissions.ShowCaller.permissions = createPermissions(_.PERMISSION_CONSTANTS, 'ShowCaller');
  return perms;
};
var createSCViewPermissions = exports.createSCViewPermissions = function createSCViewPermissions(permissions) {
  return {
    RolePermissions: {
      ShowCaller: {
        permissions: permissions
      }
    }
  };
};
var createViewPermissions = exports.createViewPermissions = function createViewPermissions(permissions) {
  return {
    RolePermissions: {
      Admin: {
        permissions: permissions
      }
    }
  };
};